var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeliveryTruck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 684 251",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "DELIVERY VAN"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    transform: "translate(-12.5 -35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455.6 186.5v-27.2",
    "data-name": "Line 47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.6 166.8V79.3a7.383 7.383 0 0 1 7.4-7.4h57.2a7.391 7.391 0 0 1 6.4 3.7l33.7 57.3a20.5 20.5 0 0 1 2.9 10.5v49a7.383 7.383 0 0 1-7.4 7.4h-37.3",
    "data-name": "Path 66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.6 186.5v5.2a6.594 6.594 0 0 0 6.6 6.6h8.3",
    "data-name": "Path 67"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.2,
    cy: 24.2,
    r: 24.2,
    "data-name": "Ellipse 17",
    transform: "translate(470.6 171.4)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    "data-name": "Ellipse 18",
    transform: "translate(481.8 182.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.2,
    cy: 24.2,
    r: 24.2,
    "data-name": "Ellipse 19",
    transform: "translate(229.7 171.4)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    "data-name": "Ellipse 20",
    transform: "translate(240.9 182.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.2,
    cy: 24.2,
    r: 24.2,
    "data-name": "Ellipse 21",
    transform: "translate(155.2 171.4)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    "data-name": "Ellipse 22",
    transform: "translate(166.4 182.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.4 103.7h-37.1a7.383 7.383 0 0 0-7.4 7.4v15a7.383 7.383 0 0 0 7.4 7.4H561",
    "data-name": "Path 68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.8 185.1h179.8",
    "data-name": "Line 48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.8 185.1h30.3",
    "data-name": "Line 49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.6 79.3V50.7a7.383 7.383 0 0 0-7.4-7.4H137a7.383 7.383 0 0 0-7.4 7.4v126.9a7.383 7.383 0 0 0 7.4 7.4h20.6",
    "data-name": "Path 69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.3 199.4H230",
    "data-name": "Line 50"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 42"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 41"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M4.5 6.4V177",
    "data-name": "Line 51"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 39"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "M0 7.7 4.5 0 9 7.7Z",
    "data-name": "Path 70"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 40"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m0 175.7 4.5 7.7 4.5-7.7Z",
    "data-name": "Path 71"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 46"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 45"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M93.3 203.4h453",
    "data-name": "Line 52"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 43"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m94.7 207.8-7.8-4.4 7.8-4.5Z",
    "data-name": "Path 72"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 44"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m544.9 207.8 7.8-4.4-7.8-4.5Z",
    "data-name": "Path 73"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 50"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 49"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m569.4 192.5 39.6-69.2",
    "data-name": "Line 53"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 47"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m573.9 193.6-7.7 4.5-.1-9Z",
    "data-name": "Path 74"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 48"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "M612.2 126.6v-8.9l-7.8 4.5Z",
    "data-name": "Path 75"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 146"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "var(--delivery-measurement-color)",
    "data-name": "Group 125",
    transform: "translate(-546.778 -6368.691)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.121,
    height: 33.49,
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6543)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.814 6547.788a2 2 0 0 1 .802 2.204l-5.854 20.574a2 2 0 0 1-3.806.132l-11.848-32.568a2 2 0 0 1 3-2.344Z",
    "data-name": "Polygon 2"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "W,W m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(609.222 198.309)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "W,W m"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 169"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "var(--delivery-measurement-color)",
    "data-name": "Group 124",
    transform: "translate(-1133.86 -6505.219)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 33,
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6541)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.798 6556.71a2 2 0 0 1 2.204-.8l20.574 5.853a2 2 0 0 1 .132 3.806l-32.568 11.848a2 2 0 0 1-2.344-3Z",
    "data-name": "Polygon 2"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "H,H m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(25.807 58.544)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "H,H m"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 171"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 170",
    transform: "translate(-883.46 -6324.938)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.121,
    height: 33.49,
    fill: "var(--delivery-measurement-color)",
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6543)"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "L,L m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(279.101 242.062)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "L,L m")), /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-measurement-color)",
    d: "M304.401 210.555a2 2 0 0 1 3.4 0l6.914 11.194a2 2 0 0 1-1.7 3.051h-13.828a2 2 0 0 1-1.7-3.051Z",
    "data-name": "Polygon 7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryTruck);
export default __webpack_public_path__ + "static/media/DeliveryTruck.16da5fcf35314dfaae35c66216cba654.svg";
export { ForwardRef as ReactComponent };